<!-- 测评报告 -->
<template>
  <div class="s-report">
    <img
      class="back-icon"
      src="@/assets/image/go-back-white.png"
      alt=""
      @click="goBack"
    >
    <div class="s-report-title">
      测评报告
    </div>

    <div class="s-report-content">
      <transition-group
        :name="transitionName"
        tag="div"
      >
        <!--第一视角 -->
        <div
          v-show="showModular"
          key="first"
          class="s-content-box1"
        >
          <div class="s-report-proposal">
            <div
              v-for="(it, index) in proposalList"
              :key="index"
              :class="['s-proposal-li', `s-li-index${index}`]"
              @click="clickChangeModel(1, it.val)"
            >
              {{ it.name }}
            </div>
            <div class="s-label-icon" />
          </div>
          <div class="s-report-text">
            <p class="s-text-content">
              你就像是在考试焦虑中披荆斩棘的航海家，面对压力也会永不放弃。现在焦虑水位已经上升到了高点，建议你进行疏导或是寻求一
              些帮助，报告中就有疏导练习和建议怕，点击“知识库里找答案”、"查看我的小建议"、“做个练习放松一下”都会给你帮助的哦~
              要知道，风雨过后就会看见彩虹，通过了焦虑的锤炼，你就会学习到如何面对它的侵袭，甚至学会让它成为你的伙伴。
            </p>
            <p class="s-text-content">
              生活的意义从来不在于完美，我们要接受和治愈自己不完美的那一面。不管你正在经历什么，不管你有多焦虑、多痛苦，一定要相
              信有人一直在默默守护你。就像现在，小星正陪伴这你。
            </p>
          </div>
        </div>

        <!-- 第二视角  -->
        <div
          v-show="!showModular"
          key="firsts"
          class="s-content-box2"
        >
          <div class="s-reoprt-tips">
            <!-- 左侧内容 -->
            <div class="s-reoprt-content">
              <img
                src="@/assets/image/label-icon.png"
                alt="个人标签"
                class="s-content-images"
              >
              <div class="s-content-label">
                <div class="s-content-tips">
                  小建议
                </div>
                <div
                  class="s-content-tips"
                  @click="goToExercise"
                >
                  平复练习
                </div>
                <div class="s-content-tips">
                  咨询预约
                </div>
              </div>
            </div>
            <!-- 右侧内容 -->
            <div class="s-reoprt-knowledge">
              <!-- <img
                src="@/assets/image/fold.png"
                alt="返回"
                class="s-knowledge-fold"
                @click="clickChangeModel(2)"
              > -->
              <div
                class="s-knowledge-fold"
                @click="clickChangeModel(2)"
              />
              <div class="s-knowledge-title">
                知识库
              </div>
              <div class="s-knowledge-cont">
                在知识讲堂中，我们为你提供了心理科普视频，你可通过查看科普视频了解和心理学方面的知识，学习缓解心理压力的技巧。
              </div>
              <div
                class="s-reoprt-video"
                @click="playVideo"
              >
                <img
                  class="s-reoprt-cover"
                  src="https://bj.download.cycore.cn/CSB-decompression-planet-service/fe99d4d3-239d-49b9-9aed-e5dcf8acaa6f/【视频】_考试焦虑的表现和成因-初高中版_mp426a40de7-6760-408c-818e-5c4659065f98.png"
                  alt="视频封面图"
                >
                <img
                  class="video-play-icon"
                  src="@/assets/image/report-play.png"
                  alt=""
                >
              </div>
            </div>
          </div>
          <div class="s-report-explain">
            <!-- 左下模块 -->
            <div class="s-explain-list">
              你就像是在考试焦虑中披荆斩棘的航海家，面对压力也会永不放弃。现在焦虑水位已经上升到了高点，建议你进行疏导或是寻求一
              些帮助，报告中就有疏导练习和建议怕，点击“知识库里找答案”、"查看我的小建议"、“做个练习放松一下”都会给你帮助的哦~
              要知道，风雨过后就会看见彩虹，通过了焦虑的锤炼，你就会学习到如何面对它的侵袭，甚至学会让它成为你的伙伴。
            </div>
            <!-- 右下模块 -->
            <div class="s-explain-audio">
              <div class="s-audio-title">
                小练习
              </div>
              <div class="s-audio-desc">
                我们为你准备了一些放松音频，你可跟随音频的指导，放慢自己的呼吸频率，平复自己的内心，让自己的头脑变得更加清醒。
              </div>
              <div
                class="s-audio-contain"
                @click="setShowAudio(true)"
              >
                <div class="s-audio-left">
                  <img
                    src="@/assets/image/report-audio-play.png"
                    alt="音频"
                    class="report-audio-play"
                  >
                  <span class="report-audio-text">安全地练习</span>
                  <img
                    src="@/assets/image/report-audio-music.png"
                    alt="音波"
                    class="report-audio-music"
                  >
                </div>
                <span class="report-audio-times">01:52</span>
              </div>
            </div>
          </div>
        </div>
      </transition-group>
    </div>

    <!-- 视频播放 -->
    <div
      v-show="showVideoPlay"
      class="s-report-video"
    >
      <div class="s-video-title clearfix">
        考试焦虑的表现和成因-初高中版
        <span
          class="s-video-close"
          @click="stopPlayVideo"
        >关闭视频</span>
      </div>
      <div class="s-video-content">
        <div id="videoWrapper" />
      </div>
    </div>

    <!-- 音频 -->
    <div
      v-show="showAudio"
      class="aduioWrapper"
    >
      <AudioPlay
        ref="setAudioInfo"
        @setShowAudio="setShowAudio"
      />
    </div>

    <!-- 跳转链接 -->
    <div
      class="link-router right-bottom"
      @click="$router.push('/measure/inventoryList')"
    />
  </div>
</template>

<script>
import AudioPlay from '@/components/audioPlay'
export default {
  components: {
    AudioPlay
  },
  props: {

  },
  data () {
    return {
      proposalList: [{
        name: '看看我的小建议',
        val: 1
      }, {
        name: '知识库里寻找答案',
        val: 2
      }, {
        name: '做个练习放松一下',
        val: 3
      }, {
        name: '去做7天考试焦虑平复练习',
        val: 4
      }, {
        name: '去找老师聊聊',
        val: 5
      }],
      transitionName: "left",
      // transitionsecond: "right",
      showModular: true, // 1 第一视角 2 第二视角
      showVideoPlay: false,
      showVideoClose: false,
      currentAudioId: "",
      playStatus: false,
      metadataTime: '00:00',
      meadiuAllTime: 0,
      //  音频播放
      showAudio: false, // 是否显示音频
    }
  },
  computed: {
  },
  created () {
    let query = this.$route.query
    this.showModular = query.type === "0" ? false : true
  },
  mounted () {

  },
  methods: {
    goBack () {
      this.$router.push('/interactive')
    },
    goToExercise () {
      this.$router.push({
        path: "/exercise",
        query: {
          type: this.showModular ? 1 : 0
        }
      })
    },
    /** type 1 第一视角 2 第二视角 */
    clickChangeModel (type, val) {
      if (type === 1 && (val === 1 || val === 2) || type === 2) {
        this.showModular = !this.showModular
        this.transitionName = !this.showModular ? "left" : "right"
      } else if (type === 1 && (val === 4 || val === 3)) {
        this.$router.push({
          path: "/exercise",
          query: {
            type: this.showModular ? 1 : 0
          }
        })
      }
    },
    playVideo () {
      if (this.player) {
        this.player.pause();
        this.player.destroy(true);
        this.player = null;
      }
      this.showVideoPlay = true;
      this.$nextTick(() => {
        this.player = new window.Player({
          id: "videoWrapper",
          url: "https://bj.download.cycore.cn/CSB-decompression-planet-service/fe99d4d3-239d-49b9-9aed-e5dcf8acaa6f/【视频】.考试焦虑的表现和成因-初高中版.mp4",
          width: "100%",
          height: "100%",
          autoplay: true,
          // videoInit: true,
          playsinline: false,
          poster: "https://bj.download.cycore.cn/CSB-decompression-planet-service/fe99d4d3-239d-49b9-9aed-e5dcf8acaa6f/【视频】_考试焦虑的表现和成因-初高中版_mp426a40de7-6760-408c-818e-5c4659065f98.png",
          ignores: ["fullscreen"],
          playbackRate: [0.75, 1.0, 1.25, 1.5, 2.0], //传入倍速可选数组
          // pip: true //打开画中画功能
        });

        this.player.on("canplay", () => {
          this.showVideoClose = true;
          //事件名称可以在上述查询
        });
        this.player.on("error", () => {
          this.showVideoClose = true;
          //事件名称可以在上述查询
        });
        this.isInit = true;
      });
    },
    stopPlayVideo () {
      this.player.destroy(true)
      this.showVideoPlay = false
      this.showVideoClose = false
      this.player = null
    },
    setShowAudio (status) {
      this.showAudio = status
      if (status) {
        this.$refs.setAudioInfo.getAudioInfo()
      }
    }
  }
}
</script>

<style scoped lang="scss">
* {
  box-sizing: border-box;
}
.s-report {
  width: 100%;
  height: 100%;
  position: relative;
  box-sizing: border-box;
  padding: 166px 0 44px;
  background: url("~@/assets/image/gauge-page-bg.png") 0 0 /100% 100%;
  overflow: hidden;
  &::-webkit-scrollbar {
    width: 0 !important ;
    height: 0 !important;
    display: none;
  }

  .link-router {
    position: fixed;
    right: 0;
    width: 100px;
    height: 100px;
    opacity: 0;
    background: #409eff;
    &.right-bottom {
      bottom: 0;
    }
  }

  .back-icon {
    position: absolute;
    left: 75px;
    top: 58px;
    width: 48px;
    height: 48px;
    z-index: 2;
  }

  .s-report-title {
    position: fixed;
    top: 55px;
    left: 0;
    width: 100%;
    height: 56px;
    font-size: 40px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #e8f0ff;
    line-height: 56px;
    text-align: center;
  }
  .s-report-content {
    width: 100%;
    height: 100%;
    > div {
      position: relative;
      display: inline-block;
      width: 100%;
      height: 100%;
    }
  }
  .s-content-box1 {
    position: absolute;
    top: 0;
    width: 100%;
    padding: 0 80px;
  }
  .s-report-proposal {
    position: relative;
    width: 100%;
    height: 479px;
    .s-proposal-li {
      cursor: pointer;
      display: inline-block;
      padding: 18px 32px;
      height: 80px;
      background: linear-gradient(300deg, #007fff 0%, #00b1ff 100%);
      border-radius: 40px;
      font-size: 32px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      line-height: 45px;
      position: absolute;
      animation: bounce-down 2.2s linear infinite;
    }
    @-webkit-keyframes bounce-down {
      25% {
        -webkit-transform: translateY(-6px);
      }
      50% {
        -webkit-transform: translateY(0px);
      }
      75% {
        -webkit-transform: translateY(6px);
      }
    }
    .s-li-index0 {
      top: 35px;
      left: 229px;
    }
    .s-li-index1 {
      top: 186px;
      left: 357px;
    }
    .s-li-index2 {
      top: 358px;
      left: 720px;
    }
    .s-li-index3 {
      top: 186px;
      right: 242px;
    }
    .s-li-index4 {
      top: 35px;
      right: 268px;
    }
    .s-label-icon {
      margin: 0 auto;
      width: 320px;
      height: 337px;
      background: url("~@/assets/image/label-icon.png") no-repeat;
      background-size: 100% 100%;
    }
  }
  .s-report-text {
    padding: 38px 140px 0;
    width: 100%;
    height: 391px;
    background: rgba(255, 255, 255, 0.15);
    box-shadow: inset 0px 0px 1px 1px rgba(255, 255, 255, 0.18);
    border-radius: 48px;
    .s-text-content {
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      line-height: 50px;
      &:nth-of-type(1) {
        margin-bottom: 28px;
      }
    }
  }
  // 第二视角
  .s-content-box2 {
    position: absolute;
    top: 0;
    width: 100%;
    height: 460px;
    padding: 0 80px;
  }
  .s-reoprt-tips {
    margin-bottom: 25px;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-around;
  }
  .s-reoprt-content {
    width: 815px;
    height: 100%;
    margin-right: 65px;
    display: flex;
    align-items: center;
    justify-content: center;
    .s-content-images {
      margin-right: 53px;
      width: 319px;
      height: 361px;
      object-fit: cover;
    }
    .s-content-label {
      .s-content-tips {
        margin-bottom: 28px;
        width: 280px;
        height: 74px;
        background: url("~@/assets/image/label-bg.png") no-repeat;
        background-size: 100% 100%;
        font-size: 34px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        line-height: 72px;
        text-align: center;
        text-shadow: 2px 2px 0px rgba(233, 143, 0, 0.5);
        &:last-child() {
          margin-bottom: 0;
        }
      }
    }
  }
  .s-reoprt-knowledge {
    padding: 28px 40px 0;
    width: 880px;
    height: 100%;
    background: url("~@/assets/image/know-bg.png") no-repeat;
    background-size: 100% 100%;
    position: relative;
    .s-knowledge-fold {
      position: absolute;
      top: 0;
      right: 0;
      width: 180px;
      height: 110px;
      display: inline-block;
      opacity: 0;
    }
    .s-knowledge-title {
      margin-bottom: 32px;
      width: 100%;
      text-align: center;
      font-size: 34px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(255, 255, 255, 0.8);
      line-height: 48px;
    }
    .s-knowledge-cont {
      margin-bottom: 22px;
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(255, 255, 255, 0.6);
      line-height: 40px;
    }
    .s-reoprt-video {
      position: relative;
      width: 800px;
      height: 230px;
      &::before {
        position: absolute;
        top: 0;
        content: "";
        display: inline-block;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
      }
    }
    .s-reoprt-cover {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    .video-play-icon {
      position: absolute;
      left: calc(50% - 32px);
      top: calc(50% - 32px);
      width: 64px;
      height: 64px;
    }
  }
  .s-report-video {
    width: 1760px;
    position: fixed;
    left: 80px;
    right: 80px;
    bottom: 0;
    top: 0;
    padding-top: 98px;
    z-index: 11;
    background: url("~@/assets/image/gauge-page-bg.png") 0 0 /100% 100%;
    .s-video-title {
      position: relative;
      height: 109px;
      line-height: 97px;
      font-size: 34px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #3f5078;
      background: #f0f2f5;
      border-radius: 16px 16px 0 0;
      text-align: center;
    }
    .s-video-close {
      position: absolute;
      top: 20px;
      right: 40px;
      width: 173px;
      height: 61px;
      font-size: 28px;
      line-height: 61px;
      background: #dadfe8;
      border-radius: 31px;
      cursor: pointer;
    }
  }
  .s-video-content {
    width: 1760px;
    height: 773px;
  }
  #videoWrapper {
    width: 100%;
    height: 100%;
    // background: brown;
    z-index: 10;
  }
  .s-report-explain {
    display: flex;
    justify-content: space-around;
    height: 396px;
    font-family: PingFangSC-Regular, PingFang SC;
  }
  .s-explain-list {
    padding: 48px 40px 0;
    width: 815px;
    height: 100%;
    margin-right: 65px;
    font-size: 28px;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.86);
    line-height: 44px;
    border-radius: 16px;
    background: rgba(255, 255, 255, 0.15);
    box-shadow: inset 0px 1px 6px 0px rgba(255, 255, 255, 0.46);
  }
  .s-explain-audio {
    padding: 28px 60px 0;
    width: 880px;
    height: 100%;
    background: url("~@/assets/image/practice-bg.png") no-repeat;
    background-size: 100% 100%;
    .s-audio-title {
      margin-bottom: 32px;
      width: 100%;
      text-align: center;
      font-size: 34px;
      font-weight: 400;
      color: rgba(255, 255, 255, 0.8);
      line-height: 48px;
    }
    .s-audio-desc {
      margin-bottom: 53px;
      font-size: 24px;
      font-weight: 400;
      color: rgba(255, 255, 255, 0.6);
      line-height: 40px;
    }
    .s-audio-contain {
      padding: 0 20px 0 20px;
      width: 100%;
      height: 56px;
      background: #20176f;
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .s-audio-left {
      display: flex;
      align-items: center;
      height: 56px;
    }
    .report-audio-play {
      margin-right: 12px;
      display: inline-block;
      width: 36px;
      height: 36px;
    }
    .report-audio-text {
      margin-right: 36px;
      font-size: 24px;
      font-weight: 400;
      color: rgba(255, 255, 255, 0.86);
      line-height: 33px;
    }
    .report-audio-music {
      // margin-right: 320px;
      display: inline-block;
      width: 128px;
      height: 20px;
    }
    .report-audio-times {
      font-size: 24px;
      font-weight: 400;
      color: rgba(255, 255, 255, 0.86);
      line-height: 33px;
    }
  }
}

.aduioWrapper {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 11;
  background: url("~@/assets/image/gauge-page-bg.png") 0 0 /100% 100%;
}

.left-enter {
  transform: translate(100%, 0);
}

.left-enter-to {
  transform: translate(0, 0);
}

.left-enter-active {
  transition: transform 1s;
}

.left-leave {
  transform: translate(0, 0);
}

.left-leave-to {
  transform: translate(-100%, 0);
}

.left-leave-active {
  transition: transform 1s;
}

.right-enter {
  transform: translate(-100%, 0);
}

.right-enter-to {
  transform: translate(0, 0);
}

.right-enter-active {
  transition: transform 1s;
}

.right-leave {
  transform: translate(0, 0);
}

.right-leave-to {
  transform: translate(100%, 0);
}

.right-leave-active {
  transition: transform 1s;
}
</style>
